import "../project.scss";
import "../projectResponse.scss";
import React from "react";

import {
    Helm
} from "../../../components";

const AllMatrix = ({lang, donors}) => {
    return (
        <div className="matrix-module">
            <Helm id={"36"} />
            <div className="donr-cards">
                <div className="partners-logo">
                    {donors.isFetched ? (
                        donors.data &&
                        donors.data.map((el, inx) => (
                            <a href={`/project/matrix/${el.id}`} className="partners-link" title={el.full_name} key={inx}>
                                <div className="partners-logo-inner">
                                    <img src={`${process.env.REACT_APP_ASSETS_URL}/images/donors/logos/${el.logo}`} alt="404" />
                                    <h4 style={{textAlign: "center"}}>{el.short_name}</h4>
                                </div>
                            </a>
                        ))
                    ) : (
                        <h5>Loading ...</h5>
                    )}
                </div>

            </div>
        </div>
    );
};

export default AllMatrix;